export const cookieLightUserRequestKey = 'LightUserRequest';
